export const TEXT_FIELD = "text_field"; // 文本输入框
export const INTEGER_FIELD = "integer_field"; // 整数输入框
export const NUMBER_FIELD = "number_field"; // 数字输入框
export const AUTOCOMPLETES = "autocompletes";
export const CHECKBOX = "checkbox";
export const COMBOBOX = "combobox";
export const OVERFLOW_BUTTONS = "overflow_buttons";
export const RADIO_BUTTONS = "radio_buttons";
export const SELECT = "select_field"; // 选择框
export const SELECT_V1 = "select_field_v1";
export const SLIDER = "slider";
export const SWITCH = "switch_field";
export const DATE_PICKER = "date_picker"; // 时间选择框
export const DATE_PICKER_V1 = "date_picker_v1"; // 时间选择框
export const MONTH_PICKER_V1 = "month_picker_v1"; // 月份选择框
export const DATE_PICKER_RANGE = "date_picker_range"; // 时间选择框
export const TEAM_SELECT = "team_select"; // 团队选择
export const TEAM_TREE_SELECT = "team_tree_select"; // 团队选择
export const COMPANY_SELECT = "company_select"; // 公司选择
export const TEXTAREAS_FIELD = "textareas_field"; // 文本输入大框
export const INVOICE_INFO_FIELD = "invoice_info_field"; // 发票税率等信息
export const MONTH_FIELD = "month_field";
export const EMPTY = "empty"; // 站位
export const AUTOCOMPLETES_ASYNC = "autocompletes_async"; // 异步
export const AUTOCOMPLETES_ASYNC_V1 = "autocompletes_async_v1"; // 异步
export const AUTOCOMPLETES_ASYNC_V2 = "autocompletes_async_v2"; // 异步
export const DATE_RANGE = "date_range";
export const DATE_RANGE_V1 = "date_range_v1";
export const TEXT_DIS = "text_dis";
export const DIST_PICKER = "dist_picker"; // 地区选择
